export enum ActivityStatus {
  IN_PROGRESS = 'InProgress',
  IN_REVIEW = 'InReview',
  COMPLETED = 'Completed',
  REMOVED = 'Removed',
  ASSIGNED = 'Assigned',
}

export enum ActivityValidStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED',
}

export default {
  ActivityStatus,
  ActivityValidStatus,
};
